











































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ name: "AgendaDetalleDrawer" })
export default class AgendaDetalleDrawer extends Vue {
  @Prop({ default: false }) public value!: boolean;
  @Prop({ default: false }) public drawerLoading!: boolean;
  @Prop({ default: null }) public drawerItem!: any;
  @Prop({ default: () => ({}) }) public drawerSolicitud!: any;
  @Prop({ default: () => ({}) }) public estadoInlineStyle!: any;
  @Prop({ default: false }) public savingAction!: boolean;
  @Prop({ default: false }) public savingDrawer!: boolean;
  @Prop({ default: null }) public copiedField!: string | null;
  @Prop({ default: () => ({}) }) public drawerForm!: any;
  @Prop({ default: () => [] }) public centrosItems!: any[];
  @Prop({ default: () => [] }) public serviciosAgrupados!: any[];
  @Prop({ default: () => [] }) public canalesDrawerItems!: any[];
  @Prop({ default: "" }) public drawerCentroText!: string;
  @Prop({ default: "" }) public drawerServicioText!: string;
  @Prop({ default: "" }) public drawerCanalText!: string;
  @Prop({ default: false }) public puedeGuardarDrawer!: boolean;
  @Prop({ required: true }) public stateColor!: (codigo: string) => string;
  @Prop({ required: true }) public formatDateTime!: (value: any) => string;
  @Prop({ required: true }) public accionColor!: (accion: string) => string;
  @Prop({ required: true }) public accionIcon!: (accion: string) => string;
  @Prop({ required: true }) public accionLabel!: (accion: string) => string;
}
